import { render, staticRenderFns } from "./powerList.vue?vue&type=template&id=b85d70dc&scoped=true"
import script from "./powerList.vue?vue&type=script&lang=js"
export * from "./powerList.vue?vue&type=script&lang=js"
import style0 from "./powerList.vue?vue&type=style&index=0&id=b85d70dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85d70dc",
  null
  
)

export default component.exports